<template>
  <Popover ref="panelPopover" placement="right" :showHeader="true" :headerTitle="panelTitle">
    <div class="schedule-panel-popover-content">
      <Spinner v-if="loading" />
      <div v-if="productionPanelData.id" class="schedule-panel-details">
        <h3 class="schedule-panel-title">Item Details</h3>
        <div class="row">
          <div class="col-3 station-popover-item-title">Barcode</div>
          <div class="col-3 station-popover-item-value">#{{productionPanelData.barcode}}</div>
          <div class="col-3 station-popover-item-title">Item Size</div>
          <div class="col-3 station-popover-item-value">{{productionPanelData.orderItem.glassHeight}}mm x {{productionPanelData.orderItem.glassWidth}}mm</div>
        </div>
        <div class="row">
          <div class="col-3 station-popover-item-title">Item Mark</div>
          <div class="col-3 station-popover-item-value">{{productionPanelData.orderItem.mark | formatHyphenEmptyValue}}</div>
        </div>
        <div class="row">
          <div class="col-3 station-popover-item-title">Stock</div>
          <div class="col-9 station-popover-item-value">{{productionPanelData.orderItem.stock.name | formatHyphenEmptyValue}}</div>
        </div>
        <div class="row">
          <div class="col-3 station-popover-item-title">Item Notes</div>
          <div class="col-9 station-popover-item-value">{{productionPanelData.orderItem.notes | formatHyphenEmptyValue}}</div>          
        </div>
        <div class="row">
          <div class="col-3 station-popover-item-title">Item Location</div>
          <div :class="['col-9', 'station-popover-item-value', !isPanelAtLocation ? 'highlighted' : '']">
            {{panelBinName | formatHyphenEmptyValue}}
          </div>          
        </div>

        <h3 class="schedule-panel-title">Order Details</h3>
        <div class="row">
          <div class="col-3 station-popover-item-title">Order</div>
          <div class="col-3 station-popover-item-value">#{{productionPanelData.order.sequenceNumber | formatHyphenEmptyValue}}</div>
          <div class="col-3 station-popover-item-title">Customer</div>
          <div class="col-3 station-popover-item-value">{{productionPanelData.order.contact.name | formatHyphenEmptyValue}}</div>
        </div>
        <div class="row">
          <div class="col-3 station-popover-item-title">Order Status</div>
          <div class="col-3 station-popover-item-value">
            <LabelOrderStatusBadge :status="productionPanelData.order.status" />
          </div>
          <div class="col-3 station-popover-item-title">Customer Ref</div>
          <div class="col-3 station-popover-item-value">{{productionPanelData.order.customerRef | formatHyphenEmptyValue}}</div>
        </div>
        <div class="row">
          <div class="col-3 station-popover-item-title">Order Due</div>
          <div class="col-3 station-popover-item-value">{{productionPanelData.order.dateCurrentlyDue | formatDate}}</div>
          <div class="col-3 station-popover-item-title">Despatch Type</div>
          <div class="col-3 station-popover-item-value">{{productionPanelData.order.despatchTaskType.name}}</div>
        </div>
        
        <div class="row">
          <div class="col-3 station-popover-item-title">Order Notes</div>
          <div class="col-9 station-popover-item-value">{{productionPanelData.order.notes | formatHyphenEmptyValue}}</div>
        </div>

        <template v-if="isOrderOnHold">
          <div class="row mt-2">
            <div class="col-12">
              <h3 class="text-danger">Order On Hold</h3>
            </div>
          </div>
          <div class="row">
            <div class="col-2 station-popover-item-title">Hold Type</div>
            <div class="col-4 station-popover-item-value">{{formatLookupName(productionPanelData.order.holdType, OrderHoldTypeLookup)}}</div>
          </div>
        </template>

        <template v-if="isPanelStopRecut">
          <div class="row mt-2">
            <div class="col-12">
              <h3>Item Recut</h3>              
            </div>
          </div>
          <div class="row">
            <div class="col-2 station-popover-item-title">Date</div>
            <div class="col-4 station-popover-item-value">{{productionPanelData.recutDate | formatDateTime}}</div>
            <div class="col-2 station-popover-item-title">Reported</div>
            <div class="col-4 station-popover-item-value">{{productionPanelData.recutReportingUser | formatHyphenEmptyValue}}</div>
          </div>
          <div class="row my-1">
            <div class="col-2 station-popover-item-title">Labels</div>
            <div class="col-10 station-popover-item-value"><LabelTags :labelList="productionPanelData.labelList" /></div>
          </div>
          <div class="row">
            <div class="col-2 station-popover-item-title">Notes</div>
            <div class="col-10 station-popover-item-value">{{productionPanelData.recutNotes | formatHyphenEmptyValue}}</div>
          </div>
        </template>

        <template v-if="isPanelRecut">
          <div class="row mt-2">
            <div class="col-12">
              <h3>Recut From</h3>
            </div>
          </div>
          <Spinner v-if="recutSourcePanelLoading" />
          <div v-if="!recutSourcePanelLoading">
            <div class="row">
              <div class="col-2 station-popover-item-title">Date</div>
              <div class="col-4 station-popover-item-value">{{recutSourcePanelData.recutDate | formatDateTime}}</div>
              <div class="col-2 station-popover-item-title">Reported</div>
              <div class="col-4 station-popover-item-value">{{recutSourcePanelData.recutReportingUser | formatHyphenEmptyValue}}</div>
            </div>
            <div class="row my-1">
              <div class="col-2 station-popover-item-title">Original</div>
              <div class="col-10 station-popover-item-value">{{recutSourcePanelData.barcode}}</div>
            </div>
            <div class="row my-1">
              <div class="col-2 station-popover-item-title">Labels</div>
              <div class="col-10 station-popover-item-value"><LabelTags :labelList="recutSourcePanelData.labelList" /></div>
            </div>
            <div class="row">
              <div class="col-2 station-popover-item-title">Notes</div>
              <div class="col-10 station-popover-item-value">{{recutSourcePanelData.recutNotes | formatHyphenEmptyValue}}</div>
            </div>
          </div>
        </template>

        <template v-if="isPanelNCR">
          <div class="row mt-2">
            <div class="col-12">
              <h3 class="text-danger">NCR</h3>
            </div>
          </div>
          <div class="row">
            <div class="col-3 station-popover-item-title">NCR Notes</div>
            <div class="col-9 station-popover-item-value">{{productionPanelData.orderItem.ncrRequestReason | formatHyphenEmptyValue}}</div>
          </div>
        </template>

        <h3 class="schedule-panel-title">Production Schedule</h3>
        <div class="row mt-3">
          <div class="col-9">
            <div class="p-0">
              <StationProgressTrackerItem
                title="Entered Production"
                :completed="true"
                :completedDate="productionPanelData.createdAt">
              </StationProgressTrackerItem>

              <template v-for="stageTask of productionPanelData.productionPanelStageTasks">
                <StationProgressTrackerItem
                  v-if="isTaskCurrent(productionPanelData.productionPanelStageTasks, stageTask) && isPanelStopRecut"
                  :key="`recut-${stageTask.id}`"
                  title="Issue - Recut"
                  :errored="true"
                  :completed="false"
                  :current="false"
                  >
                </StationProgressTrackerItem>

                <StationProgressTrackerItem
                  :key="stageTask.id"
                  :title="stageTask.productionStage.name"
                  :completed="stageTask.status == ProductionPanelStageTaskStatusTypes.completed"
                  :current="isTaskCurrent(productionPanelData.productionPanelStageTasks, stageTask) && !isPanelStopRecut && !isPanelStopCancelled"
                  :dueDate="stageTask.dueDate"
                  :completedDate="stageTask.completionDate"
                  :locationName="getStageTaskLocationName(stageTask)"
                  >
                </StationProgressTrackerItem>
              </template>

              <StationProgressTrackerItem
                v-if="isPanelShowingDespatch"
                title="Despatch"
                icon="fa-truck"
                :completed="isPanelCompleted"
                :locationName="getDespatchLocationName()">
                {{productionPanelData.order.despatchTaskType.name}}
              </StationProgressTrackerItem>
            </div>
          </div>
          <div class="col-3">
            <button class="station-popover-button btn btn-primary btn-block" @click.prevent="orderClicked"><i class="far fa-shopping-cart"></i><br />Order</button>
            <button class="station-popover-button btn btn-primary btn-block" @click.prevent="orderItemsClicked"><i class="far fa-info-circle"></i><br />Order Items</button>
            <button class="station-popover-button btn btn-primary btn-block" @click.prevent="orderDocumentsClicked"><i class="far fa-book"></i><br />Documents</button>
            <button class="station-popover-button btn btn-primary btn-block" @click.prevent="orderEditorViewClicked" v-if="isOrderEditorViewAvailable"><i class="far fa-ruler-combined"></i><br />Editor View</button>
            <button class="station-popover-button btn btn-success btn-block" @click.prevent="printLabelClicked" v-if="isPrintLabelAvailable"><i class="far fa-print"></i><br />{{printLabelButtonTitle}}</button>
            <button class="station-popover-button btn btn-success btn-block" @click.prevent="moveClicked" v-if="isMoveAvailable"><i class="far fa-random"></i><br />Move</button>
            <button class="station-popover-button btn btn-warning btn-block" @click.prevent="recutClicked" v-if="isRecutAvailable"><i class="far fa-sync"></i><br />Recut</button>
            <button class="station-popover-button btn btn-info btn-block" @click.prevent="revertClicked" v-if="isRevertAvailable"><i class="far fa-undo"></i><br />Revert</button>
          </div>
        </div>
      </div>
      <div class="text-center text-danger" v-if="loadingError">{{loadingError}}</div>
    </div>
  </Popover>
</template>

<style lang="scss" scoped>
$options-height: 60px;

.schedule-panel-popover-content {
  min-width: 550px;
  min-height: 200px;
  padding: 8px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
.schedule-panel-title {
  margin-top: 10px;
  margin-bottom: 5px;
}
.schedule-panel-details {
  flex: 1;
}

</style>

<script>
import Popover from '@/components/popover'
import StationProgressTrackerItem from '@/apps/glass-production-station/src/components/schedule/stationProgressTrackerItem'
import LabelOrderStatusBadge from '@/modules/orders/components/labelOrderStatusBadge'

import { ProductionPanelStatusTypes, ProductionPanelStageTaskStatusTypes, OrderStatusTypeLookup, OrderTypes, OrderHoldTypeLookup, ProductionPanelTypes } from '@/store/types'

export default {
  name: 'SchedulePanelPopover',
  components: {
    Popover,
    StationProgressTrackerItem,
    LabelOrderStatusBadge
  },
  data() {
    return {
      loading: false,
      loadingError: '',
      productionPanelId: null,
      productionPanelData: {},

      // Station the panel popover is displayed from
      productionStationId: null,
      productionStationData: {},

      recutSourcePanelLoading: false,
      recutSourcePanelData: {}
    }
  },
  computed: {
    panelTitle() {
      if(this.loading)
        return 'Loading Item...'
      if(this.loadingError)
        return 'Error loading item'

      var typeName = 'Item'
      if(this.productionPanelData.type == ProductionPanelTypes.assembly)
        typeName = 'Assembly'

      return `${typeName} ${this.productionPanelData.barcode}`
    },
    printLabelButtonTitle() {
      if(this.productionPanelData.isPanelLabelPrinted)
        return 'Reprint Label'
      return 'Print Label'
    },
    isPanelStopRecut() {
      return this.productionPanelData.status == ProductionPanelStatusTypes.recut
    },
    isPanelStopCancelled() {
      return this.productionPanelData.status == ProductionPanelStatusTypes.cancelled
    },
    isPanelCompleted() {
      return this.productionPanelData.status == ProductionPanelStatusTypes.completed
    },
    isPanelNCR() {
      if(!this.productionPanelData.order)
        return false
      return this.productionPanelData.order.type == OrderTypes.nonChargeableRework
    },
    isPrintLabelAvailable() {
      if(this.isPanelStopRecut || this.isPanelStopCancelled)
        return false

      // KC: 25/09/2023 - Disable panel label printing via the popup until it has been printed (via orders, or cutting stations)
      // Prevents people manually printing labels & manually cutting
      if(!this.productionPanelData.isPanelLabelPrinted)
        return false

      return true
    },
    isPanelRecut() {
      return this.productionPanelData.isRecut
    },
    isMoveAvailable() {
      if(this.productionPanelData.status == ProductionPanelStatusTypes.production || 
         this.productionPanelData.status == ProductionPanelStatusTypes.despatch)
        return true
      
      return false
    },
    isRecutAvailable() {
      if(this.productionPanelData.status == ProductionPanelStatusTypes.production || 
         this.productionPanelData.status == ProductionPanelStatusTypes.despatch)
        return true
      
      return false
    },
    isRevertAvailable() {
      if(!this.userHasUpdatePermission(this.PermissionTypes.ProductionPermissionTypes.productionAdministrator))
        return false
      if(this.productionPanelData.status == ProductionPanelStatusTypes.production || 
         this.productionPanelData.status == ProductionPanelStatusTypes.despatch)
        return true
      
      return false
    },
    isOrderEditorViewAvailable() {
      if(!this.userHasReadPermission(this.PermissionTypes.OrderEditorPermissionTypes.orderEditor))
        return false
      if(this.productionPanelData.orderItem && this.productionPanelData.orderItem.isEditorGeneratedItem)
        return true

      return false
    },
    isOrderOnHold() {
      return this.productionPanelData.order.isOnHold
    },
    panelHasTransfers() {
      return this.productionPanelData.hasProductionTransfers || this.productionPanelData.hasDespatchTransfers
    },
    isPanelAtLocation() {
      if(this.productionPanelData.inventoryBin && this.productionStationData) {
        return this.productionPanelData.inventoryBin.accountLocationId == this.productionStationData.accountLocationId
      }
      return true
    },
    panelBinName() {
      if(this.productionPanelData.inventoryBin) {
        return `${this.productionPanelData.inventoryBin.code} | ${this.productionPanelData.inventoryBin.accountLocation.name}`
      }
      return ''
    },
    isPanelShowingDespatch() {
      return !this.productionPanelData.isInternalItem
    }
  },
  created() {
    this.ProductionPanelStatusTypes = ProductionPanelStatusTypes
    this.ProductionPanelStageTaskStatusTypes = ProductionPanelStageTaskStatusTypes
    this.OrderStatusTypeLookup = OrderStatusTypeLookup
    this.OrderHoldTypeLookup = OrderHoldTypeLookup
  },
  methods: {
    displayFromElement(element, panelInfo, productionStationId) {
      this.$refs.panelPopover.displayFromElement(element)

      // Reset
      this.productionPanelData = {}
      this.productionPanelId = panelInfo.id
      this.productionStationId = productionStationId
      this.productionStationData = {}

      this.requestData()
    },

    requestData() {
      this.loading = true
      this.loadingError = ''

      Promise.all([
        this.$apiService.glassProductionStationService.getProductionPanel(this.productionPanelId),
        this.$apiService.productionService.getProductionStation(this.productionStationId)
      ])
      .then(results => {
        this.productionPanelData = results[0].data
        this.productionStationData = results[1].data

        // If a recut, load the source panel too
        if(this.productionPanelData.isRecut) {
          this.requestSourceRecutPanel(this.productionPanelData.originalProductionPanelId)
        }

        // Update popover to adjust for content
        this.$nextTick(() => {
          this.$refs.panelPopover.updatePopper()
        })
      })
      .catch(err => {
        this.loadingError = 'Error loading panel data'
      })
      .finally(() => {
        this.loading = false
      })
    },
    requestSourceRecutPanel(originalPanelId) {
      this.recutSourcePanelLoading = true

      this.$apiService.glassProductionStationService.getProductionPanel(originalPanelId)
      .then(response => {
        this.recutSourcePanelData = response.data

        // Update popover to adjust for content
        this.$nextTick(() => {
          this.$refs.panelPopover.updatePopper()
        })
      })
      .catch(err => {
        this.loadingError = 'Error loading original panel data'
      })
      .finally(() => {
        this.recutSourcePanelLoading = false
      })
    },

    isTaskCurrent(stageTaskList, stageTask) {
      if(stageTask.status == ProductionPanelStageTaskStatusTypes.production)
        return true

      // If pending, and all tasks have been completed up to here, then this task is current
      // If no prior tasks, then this is the first & current task
      if(stageTask.status == ProductionPanelStageTaskStatusTypes.pending) {
        let previousTask = stageTaskList.find(taskItem => taskItem.taskOrder == stageTask.taskOrder-1)
        if(!previousTask || previousTask.status == ProductionPanelStageTaskStatusTypes.completed)
          return true
      }
      return false
    },

    getStageTaskLocationName(stageTask) {
      // Ignore if panel has no production/despatch transfers
      if(!this.panelHasTransfers)
        return ''

      var accLocation = this.$store.getters['account/getAccLocationById'](stageTask.accountLocationId)
      if(accLocation)
        return accLocation.name

      return ''
    },
    getDespatchLocationName() {
      // Ignore if panel has no production/despatch transfers
      if(!this.panelHasTransfers)
        return ''

      var accLocation = this.$store.getters['account/getAccLocationById'](this.productionPanelData.order.accountLocationId)
      if(accLocation)
        return accLocation.name

      return ''
    },

    orderClicked() {
      this.$refs.panelPopover.hidePopover()
      this.$emit('orderClick', this.productionPanelData)
    },
    orderItemsClicked() {
      this.$refs.panelPopover.hidePopover()
      this.$emit('orderItemsClick', this.productionPanelData)
    },
    orderDocumentsClicked() {
      this.$refs.panelPopover.hidePopover()
      this.$emit('orderDocumentsClick', this.productionPanelData)
    },
    orderEditorViewClicked() {
      this.$refs.panelPopover.hidePopover()
      this.$emit('orderEditorViewClick', this.productionPanelData)
    },
    printLabelClicked() {
      this.$refs.panelPopover.hidePopover()
      if(this.productionPanelData.isPanelLabelPrinted)
        this.$emit('reprintLabelClick', this.productionPanelData)
      else
        this.$emit('printLabelClick', this.productionPanelData)
    },
    recutClicked() {
      this.$refs.panelPopover.hidePopover()
      this.$emit('recutClick', this.productionPanelData)
    },
    revertClicked() {
      this.$refs.panelPopover.hidePopover()
      this.$emit('revertClick', this.productionPanelData)
    },
    moveClicked() {
      this.$refs.panelPopover.hidePopover()
      this.$emit('moveClick', this.productionPanelData)
    }
  }
}
</script>